import React, { Suspense } from 'react';
// import { AuthContextComponent } from 'src/contexts/auth.context';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { MultiPathRoute } from './routes';
import './pages/main/main.scss';

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useLayoutEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }, 50);
  }, [pathname]);

  return null;
}

const MainPage = React.lazy(() => import('./pages/main/main.page'));
const ProjectPage = React.lazy(() => import('./pages/project/project.page'));
// const AdminPage = React.lazy(() => import('./pages/admin/admin.page'));
// const NotFoundPage = React.lazy(() => import('./pages/misc/404.page'));

export const ROUTES = {
  HOME: '/',
  PROJECT: (id: string) => `/project/${id}`,
} as const;

function App() {
  return (
    <Router>
      <ScrollToTop/>
      {/* <AuthContextComponent> */}
        <Suspense fallback={<div></div>}>
          <Routes>
            {/* <Route path="*" element={<MultiPathRoute paths={["/","/projects","/museums","/brands","/team","/contact"]} element={<MainPage/>} />} /> */}

            <Route path='/project/:projectId' element={<ProjectPage/>} />
            <Route path="*" element={<MainPage />}  />
            {/* <Route path="*" element={<MultiPathRoute paths={["/"]} element={<p className="in-development">Website in development, come back later.</p>} />} /> */}

            {/* <Route path='/404' element={NotFoundPage} /> */}
          </Routes>
        </Suspense>
      {/* </AuthContextComponent> */}
    </Router>
  );
}

export default App;
